import axios from "axios";

export default function () {
	const userString = window.localStorage.getItem(
		`oidc.user:${process.env.VUE_APP_authority}:FertigungClient`
	);
	const user = JSON.parse(userString);
	return axios.create({
		baseURL: process.env.VUE_APP_SERVER_URL,
		headers: {
			Authorization: "Bearer " + user.access_token,
		},
	});
}
